import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

const getDisplayString = (sub) => {
  const arr = sub.split("-");
  if (arr.length > 1) {
    return arr[0].charAt(0).toUpperCase() + arr[0].slice(1) + " " + arr[1].charAt(0).toUpperCase() + arr[1].slice(1)
  } else {
    return sub.charAt(0).toUpperCase() + sub.slice(1)
  }

};
const getUrlString = (path, sub, index) => {
  if (index === 0) {
    return '#/';
  } else {
    return '#/' + path.split(sub)[0] + sub;
  }
};

class ContainerHeader extends React.Component {

  render() {
    const path = this.props.match.path.substr(1);
    const subPath = path.split('/');
    return (
      <div style={{ padding: '20px 20px 20px 20px' }} className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
        <h2 className="title mb-3 mb-sm-0">{this.props.orgName !== null ? this.props.orgName : ""} </h2>
        <Breadcrumb className="mb-0" tag="nav">
          {subPath.map((sub, index) => {
            return <BreadcrumbItem active={subPath.length === index + 1}
              tag={subPath.length === index + 1 ? "span" : "a"} key={index}
              href={getUrlString(path, sub, index)}>{getDisplayString(sub)}</BreadcrumbItem>
          }
          )}
        </Breadcrumb>
      </div>
    );
  }
}

// const ContainerHeader = ({ title, match }) => {
//   // const path = match.path.substr(1);
//   // const subPath = path.split('/');
//   return (
//     <div style={{ padding: '20px 20px 20px 20px' }} className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
//       <h2 className="title mb-3 mb-sm-0">{this.props.orgId} <span> </span> {title}</h2>
//     </div>
//   )
// };

const mapStateToProps = ({ auth }) => {
  const { orgId, orgName } = auth.authUser;
  return { orgId, orgName }
}
export default withRouter(connect(mapStateToProps)(ContainerHeader));

